import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TeamMemberRow } from "../teamViewConfig";
import { MemberActionsCell } from "./MemberActionsCell";
import { InviteActionsCell } from "./InviteActionsCell";

export const ActionsCell = ({
    row,
}: CellContext<ViewTableFeatures, TeamMemberRow, any>) => {
    const member = row.original;

    if (member.type === "member") {
        return <MemberActionsCell member={member} />;
    }

    return <InviteActionsCell invite={member} />;
};
